export const footerLinkUrl = {
  googleDownload: 'https://play.google.com/store/apps/details?id=com.joybuy.jdi',
  AppDownload: 'https://apps.apple.com/app/joybuy/id6740224837',
};

export const getBasicData = (t: (key: string) => string) => {
  return {
    AboutBasicList: [
      {
        title: t('footer.about'),
        urlName: 'about-us',
        url: '/discover/about-us',
      },
      {
        title: t('footer.contact'),
        urlName: 'contact-us',
        url: '/discover/contact-us',
      },
    ],
    LegalBasicList: [
      {
        title: t('footer.cookiesPolicy'),
        urlName: 'cookie-policy',
        url: '/help/cookie-policy',
      },
      {
        title: t('footer.privacyPolicy'),
        urlName: 'privacy-policy',
        url: '/help/privacy-policy',
      },
      {
        title: t('footer.termsAndConditions'),
        urlName: 'terms-conditions',
        url: '/help/terms-conditions',
      },
    ],
    ContactBasicList: [
      {
        title: t('footer.email'),
        urlName: 'emial',
        contactMethod: "<a href='mailto:support@joybuy.com'>support@joybuy.com</a>",
      },
      {
        title: t('footer.phone'),
        urlName: 'phone',
        contactMethod: "<a href='tel:44 20 3816 1661'>+44 20 3816 1661</a>",
      },
    ],
  };
};
